import React, { useEffect, useState } from "react";
import VersionHistoryBtn from "../../components/buttons/versionHistoryBtn";
import "./superUsers.css";
import back from "../../assets/back.svg";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import CreateBtn from "../../components/buttons/createBtn";
import InputField from "../../components/form/inputField/inputField";
import { NavLink, useNavigate } from "react-router-dom";
import { AdminButton } from "../../components/buttons/versionHistoryBtn";
import ErrorMsg from "../../components/form/errorMsg";
import { useDispatch } from "react-redux";
import { fetchDivisionList } from "../../redux/actions/commonActions";
import {
  createSuperUser,
  fetchRoleList,
  permissionsList,
} from "../../redux/actions/superUserAction";
import { vendorDivisionList } from "../../redux/actions/productActions";
import CreatedPopUp from "../../components/popups/CreatedPopUp";
import InputCapitalField from "../../components/form/inputField/inputCapitalField";
import ErrorPopup from "../../components/popups/ErrorPopup";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";

const SuperUserCreate = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [divisionOptions, setDivisionOptions] = useState([]);
  const [permission, setPermission] = useState([]);
  const [settingId, setSettingID] = useState(null);
  const [created, setCreated] = useState(false);

  const phoneRegex = /^([+]\d{2})?\d{10}$/;

  const initialValues = {
    employee_id: "",
    name: "",
    email: "",
    mobile: "",
    divisions: [],
    role_id: "",
  };

  useEffect(() => {
    dispatch(vendorDivisionList(fetchDivisionSuccess, fetchDivisionError));
    dispatch(fetchRoleList(fetchPermissionSuccess, fetchPermissionError));
  }, []);

  const fetchPermissionSuccess = (data) => {
    console.log("permissions", data);
    setPermission(data);
  };

  const fetchPermissionError = (data) => {
    console.log(data);
  };

  const fetchDivisionSuccess = (data) => {
    setDivisionOptions(data);
  };

  const fetchDivisionError = (err) => {
    console.log(err);
  };

  const validationSchema = Yup.object().shape({
    employee_id: Yup.string().required("Required"),
    name: Yup.string().required("Required"),
    email: Yup.string().email("Not a proper email").required("Required"),
    mobile: Yup.string()
      .matches(phoneRegex, "Not a valid Number")
      .required("Required"),
    divisions: Yup.array()
      .min(1, "At least one should be selected")
      .required("Required"),
    role_id: Yup.string().required("Required"),
  });

  const clearFunc = (setFieldValue) => {
    setFieldValue("employee_id", "");
    setFieldValue("name", "");
    setFieldValue("email", "");
    setFieldValue("mobile", "");
    setFieldValue("divisions", []);
    setFieldValue("role_id", "");
  };

  const onSubmit = (values) => {
    console.log(values);
    dispatch(createSuperUser(values, onSuccess, onError));
  };
  const onSuccess = (data) => {
    console.log(data);
    setCreated(true);
    const timeOutFnc = () => {
      setCreated(false);
      navigate("/super-user/user");
    };

    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    console.log(err);
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };
  const routes = [
    { path: "/", breadcrumb: "Admin" },
    {
      path: "/super-user/user",
      breadcrumb: " / super users",
    },
    {
      path: "/super-user/user/create",
      breadcrumb: " / create",
    },
  ];
  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });
  return (
    <div className="products-page">
      <div className="products-main-div">
        <div className="mx-3">
          {breadcrumbs.map(({ match, breadcrumb }) => (
            <NavLink
              key={match.pathname}
              to={match.pathname}
              className="header-route-page fw_400 cursor_pointer"
            >
              <span className="fs_18">{breadcrumb}</span>
            </NavLink>
          ))}
        </div>
        <div className="products-main-list my-2 py-1">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ setFieldValue, values }) => (
              <Form className="">
                <div className="search-container d-flex justify-content-between align-items-center">
                  <div
                    className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
                    onClick={() => navigate(-1)}
                  >
                    <img src={back} alt="back_btn" />
                    <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                      BACK
                    </span>
                  </div>
                  <div className=" d-flex justify-content-between m-1 mb-2">
                    <AdminButton
                      background="#E7E5FF"
                      width="100px"
                      type="button"
                      onClick={() => clearFunc(setFieldValue)}
                    >
                      CLEAR
                    </AdminButton>
                    <AdminButton
                      background="#7065e4"
                      color="white"
                      width="100px"
                      type="submit"
                    >
                      <span className="m-2">SAVE</span>
                    </AdminButton>
                  </div>
                </div>
                <div className="scrolling">
                  <div className="form-width ms-4 ps-3 py-1">
                    <div className="my-4 ">
                      <InputCapitalField
                        id={"employee_id"}
                        setFieldValue={setFieldValue}
                        label={"Company Employee ID"}
                        labelColor={"color_262c3d"}
                        type={"text"}
                        placeholder={"Enter employee id"}
                        name={"employee_id"}
                        value={values?.employee_id}
                      />
                    </div>
                    <div className="my-4">
                      <InputCapitalField
                        setFieldValue={setFieldValue}
                        id={"name"}
                        label={"Name"}
                        labelColor={"color_262c3d"}
                        type={"text"}
                        placeholder={"Enter name"}
                        name={"name"}
                        value={values?.name}
                      />
                    </div>
                    <div className="my-4">
                      <label className="color_262c3d fw_400 fs_14 my-1 f">
                        Role
                      </label>
                      <Field>
                        {({ field }) => (
                          <Select
                            {...field}
                            options={permission}
                            styles={customStyles}
                            placeholder={"Enter role"}
                            value={permission.filter(
                              (s) => s.value == values.role_id
                            )}
                            onChange={(selected) => {
                              setFieldValue("role_id", selected?.value);
                            }}
                          />
                        )}
                      </Field>
                      <ErrorMsg name="divisions" />
                    </div>
                    <div className="my-4">
                      <InputField
                        id={"email"}
                        setFieldValue={setFieldValue}
                        label={"Email Address"}
                        labelColor={"color_262c3d"}
                        type={"text"}
                        placeholder={"Enter email address"}
                        name={"email"}
                        value={values?.email}
                      />
                    </div>
                    <div className="my-4">
                      <InputField
                        maxLength="10"
                        id={"mobile"}
                        setFieldValue={setFieldValue}
                        label={"Phone Number"}
                        labelColor={"color_262c3d"}
                        type={"text"}
                        placeholder={"Enter phone number"}
                        name={"mobile"}
                        value={values?.mobile}
                      />
                    </div>
                    <div className="my-4">
                      <label className="color_262c3d fw_400 fs_14 my-1 f">
                        Divisions Name
                      </label>
                      <Field>
                        {({ form, Field }) => (
                          <Select
                            isMulti
                            options={divisionOptions}
                            styles={customStyles2}
                            {...Field}
                            placeholder={"Select divisions"}
                            id="divisions"
                            value={divisionOptions.filter((o1) =>
                              values?.divisions?.some((o2) => o2 == o1.value)
                            )}
                            onChange={(selectedOption) => {
                              let newArr = values.divisions;
                              form.setFieldValue(
                                "divisions",
                                selectedOption
                                  ? selectedOption.map((item) => item.value)
                                  : []
                              );
                            }}
                          />
                        )}
                      </Field>
                      <ErrorMsg name="divisions" />
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
          <CreatedPopUp
            show={created}
            handelClose={() => setCreated(false)}
            title={"Super User Created Successfully"}
          />
          <ErrorPopup
            show={showErrorPopup}
            title={showErrorMsg}
            handleClose={closeErrorPopup}
          />
        </div>
      </div>
    </div>
  );
};

export default SuperUserCreate;
export const customStyles = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    border: "1px solid #B0B3C7",
    color: "#464646",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    fontSize: "15px",
    borderRadius: "8px",
    width: "100%",
    maxWidth: "450px",
    height: "40px",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "#B0B3C7",
      fontSize: "14px",
      fontFamily: "Nunito Sans",
    };
  },
  dropdownIndicator: (base) => ({
    ...base,
    color: "#a9a3e3", // Custom colour
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#E7E5FF" : null,
    color: "#00000",

    // fontFamily: "Nunito",
    "&:hover": {
      backgroundColor: state.isFocused ? "#E7E5FF" : "#E7E5FF",
    },
  }),
};

export const customStyles2 = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    border: "1px solid #B0B3C7",
    color: "#464646",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    fontSize: "15px",
    borderRadius: "8px",
    width: "100%",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "#B0B3C7",
      fontSize: "14px",
      fontFamily: "Nunito Sans",
    };
  },
  dropdownIndicator: (base) => ({
    ...base,
    color: "#a9a3e3", // Custom colour
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#E7E5FF" : null,
    color: "#00000",
    // fontFamily: "Nunito",
    "&:hover": {
      backgroundColor: state.isFocused ? "#E7E5FF" : "#E7E5FF",
    },
  }),
};
